import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonCheckbox from '../components/CommonCheckbox';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';
import CommonFile from '../components/CommonFile';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

/**
    import CommonRadio from '../components/CommonRadio';
*/

import InlineEB03DataTrainingDetails from '../inline/InlineEB03DataTrainingDetails';
import InlineEB03DataTrainingDetailsEnterprise from '../inline/InlineEB03DataTrainingDetailsEnterprise';
import InlineCertificationEB04 from '../inline/InlineCertificationEB04';
import InlineSatisfactionAssessmentEB05 from '../inline/InlineSatisfactionAssessmentEB05';

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

class InputEB03DataCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date(),
            DrillDowns: {
                training_details_enterprise_eb_03: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                },  
                certification_eb_04: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                },  
                satisfaction_assessment_eb_05: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                },                                       
            }               
        }
        
        this.simpleBarRef = React.createRef();
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); };

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            this.resetState();
            await this.prepareInputs();
        }
    }    

    drillDownInline = ({key, fk = null, val = null, page = null, drilldown = false, restore = {}}) => {
        this.setState(prevState => {
            const updatedDrillDowns = {
                ...prevState.DrillDowns,
                [key]: { 
                    drilldown : true, fk, val, page 
                }
            };

            if (['certification_eb_04', 'satisfaction_assessment_eb_05'].includes(key) && prevState.DrillDowns.training_details_enterprise_eb_03) {
                updatedDrillDowns.training_details_enterprise_eb_03 = {
                    ...prevState.DrillDowns.training_details_enterprise_eb_03,
                    drilldown: false
                };              
            }

            return {
                ...prevState,
                DrillDowns: updatedDrillDowns
            };
        }, () => {
             console.log("debugging drilldown inline =", this.state);
        });            
    }

    drillUpInline = ({key}) => {
        this.setState(prevState => {
            
            const updatedDrillDowns = {
                ...prevState.DrillDowns,
                [key]: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null,
                }
            }; 
            
            if (['certification_eb_04', 'satisfaction_assessment_eb_05'].includes(key) && prevState.DrillDowns.training_details_enterprise_eb_03) {
                updatedDrillDowns.training_details_enterprise_eb_03= {
                    ...prevState.DrillDowns.training_details_enterprise_eb_03,
                    drilldown: true
                };
            }   
            
            return {
                ...prevState,
                DrillDowns: updatedDrillDowns
            };
        }, () => {
            // console.log("debugging drillup inline =", this.state);
        });              
    } 
    
    resetState = () => {
        this.setState({
            selectedDate: new Date(),
            DrillDowns: {
                training_details_enterprise_eb_03: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                },
                certification_eb_04: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                },
                satisfaction_assessment_eb_05: {
                    drilldown: false,
                    fk: null,
                    val: null,
                    page: null
                }                
            }
        });
    };     
    
    render = () => {

        let props = this.props;

        let AllowUsersTypes = ['0', '1', '2' ]; // 0=Admin, 1=EEC staff, 2=acdemy

        let { onNavigate, onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onPreviewFile, onDeleteFile  } = props;

        let { App, Action, Inputs, ReadOnlys, InputGroup, Masterbase, Operation, UserCookie } = props;
        
        let { DrillDowns } = this.state;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
            <>
            <Offcanvas 
                show={show}
                placement="end" 
                style={{ '--bs-offcanvas-width': '100vw' }}
                backdrop={Submit ? "static" : true}
                onHide={(e) => props.onClose(e)}
            >
                <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                    <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="custom-offcanvas-body">
                    
                    <CommonAlert 
                        alert={Action.Alert} 
                        
                        callback={(e) => onCloseAlert(e)}
                    />

                    <SimpleBar id="inputs" className="simple-bar-input" ref={this.simpleBarRef}>
                        <Container fluid className="data-table-container">

                            <Row>
                                <Col md={{ span: 12, offset: 0 }} className="eb-form-container">
                                    
                                    <Row>
                                        <Col md={12} className="d-flex align-items-center justify-content-center text-center">
                                            <h5>แบบรายงานผลการจัดอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</h5>
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col md={12} className="mb-3">
                                            <label className="form-label"><b>1. หลักสูตร</b></label>
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('1.1 ', Inputs.course_eb_02_id)}</Col>
                                        <Col md={3} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.course_eb_02_id}
                                                option={{source: 'db', data: Masterbase?.course_eb_02}}
                                                instanceOptionName="official_course_code"
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    // await this.draftInput(e);
                                                }}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />
                                        </Col> 
                                        <Col md={3} className="mb-3">
                                            <div className="d-flex justify-content-between w-100">
                                                <span>{util.formatLabel('(ตามที่ได้รับอนุมัติจาก สกพอ.)', '')}</span>
                                                <span>{util.formatLabel('', ReadOnlys.budget_code)}</span>
                                            </div>
                                        </Col>
                                        <Col md={2} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.budget_code.id}
                                                name={ReadOnlys.budget_code.id}
                                                value={
                                                    Masterbase?.course_eb_02?.find((a) => a.id === Inputs.course_eb_02_id?.value)?.budget_code || ''
                                                }
                                                placeholder={ReadOnlys.budget_code.label}
                                                disabled={true}
                                            />
                                        </Col> 
                                    </Row>   
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('1.2 ', ReadOnlys.course_eb_02_name)}</Col>
                                        <Col md={8} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.course_eb_02_name.id}
                                                name={ReadOnlys.course_eb_02_name.id}
                                                value={
                                                    Masterbase?.course_eb_02?.find((a) => a.id === Inputs.course_eb_02_id?.value)?.course_eb_02_name || ''
                                                }
                                                placeholder={ReadOnlys.course_eb_02_name.label}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('1.3 ', ReadOnlys.academy_name)}</Col>
                                        <Col md={4} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.academy_name.id}
                                                name={ReadOnlys.academy_name.id}
                                                value={
                                                    Masterbase?.course_eb_02?.find((a) => a.id === Inputs.course_eb_02_id?.value)?.academy_name || ''
                                                }
                                                placeholder={ReadOnlys.academy_name.label}
                                                disabled={true}
                                            />
                                        </Col>   
                                        <Col md={1} className="mb-3">{util.formatLabel('', ReadOnlys.academy_province_name)}</Col>
                                        <Col md={3} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.academy_province_name.id}
                                                name={ReadOnlys.academy_province_name.id}
                                                value={
                                                    Masterbase?.course_eb_02?.find((a) => a.id === Inputs.course_eb_02_id?.value)?.academy_province_name || ''
                                                }
                                                placeholder={ReadOnlys.academy_province_name.label}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} className="d-flex align-items-center justify-content-end mb-3">{util.formatLabel('', Inputs.academy_detail)}</Col>
                                        <Col md={4} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.academy_detail}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>   
                                        <Col md={3} className="mb-3">
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('1.4 ', Inputs.course_coordinator)}</Col>
                                        <Col md={4} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.course_coordinator}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>   
                                        <Col md={1} className="mb-3">{util.formatLabel('', Inputs.coordinator_department)}</Col>   
                                        <Col md={3} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.coordinator_department}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel('', Inputs.coordinator_email)}</Col> 
                                        <Col md={3} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.coordinator_email}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>   
                                    </Row>
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel('', Inputs.coordinator_contact)}</Col> 
                                        <Col md={3} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.coordinator_contact}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>        
                                    </Row> 
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('1.5 รายละเอียดการจัดอบรม', '')}</Col> 
                                    </Row>     

                                    {   DrillDowns.training_details_enterprise_eb_03.drilldown === false && 
                                        DrillDowns.certification_eb_04.drilldown === false && 
                                        DrillDowns.satisfaction_assessment_eb_05.drilldown === false 
                                        && 
                                    (
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                                <InlineEB03DataTrainingDetails
                                                    fkId="course_eb_03_id"
                                                    fkVal={Inputs.id.value}

                                                    onDrillDownInline={(e) => this.drillDownInline(e)}
                                                /> 
                                            </Col>  
                                        </Row>  
                                    )}  

                                    {DrillDowns.training_details_enterprise_eb_03.drilldown === true && (    
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">   
                                                <InlineEB03DataTrainingDetailsEnterprise
                                                    refKey='training_details_enterprise_eb_03'
                                                    refPage={DrillDowns.training_details_enterprise_eb_03.page}
                                                    
                                                    fkId="training_details_eb_03_id"
                                                    fkVal={DrillDowns.training_details_enterprise_eb_03.val}

                                                    onDrillDownInline={(e) => this.drillDownInline(e)}
                                                    onDrillUpInline={(e) => this.drillUpInline(e)}
                                                />
                                            </Col>  
                                        </Row>            
                                    )}      

                                    {DrillDowns.certification_eb_04.drilldown === true && (    
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">                
                                                <InlineCertificationEB04
                                                    refKey='certification_eb_04'
                                                    refPage={DrillDowns.certification_eb_04.page}
                                                    
                                                    fkId="training_details_enterprise_eb_03_id"
                                                    fkVal={DrillDowns.certification_eb_04.val}
                                                    fkUserCookie={UserCookie}

                                                    onDrillUpInline={(e) => this.drillUpInline(e)}
                                                />   
                                            </Col>  
                                        </Row>            
                                    )}
 
                                     {DrillDowns.satisfaction_assessment_eb_05.drilldown === true && (    
                                        <Row>
                                            <Col md={{ span: 12, offset: 0 }} className="mb-3">                
                                                <InlineSatisfactionAssessmentEB05
                                                    refKey='satisfaction_assessment_eb_05'
                                                    refPage={DrillDowns.satisfaction_assessment_eb_05.page}
                                                    
                                                    fkId="training_details_enterprise_eb_03_id"
                                                    fkVal={DrillDowns.satisfaction_assessment_eb_05.val}   

                                                    onDrillUpInline={(e) => this.drillUpInline(e)}
                                                />   
                                            </Col>  
                                        </Row>            
                                    )}
 
                                    <Row className="mt-3">
                                        <Col md={3} className="mb-3">{util.formatLabel('1.6 ', Inputs.trainee_amount)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.trainee_amount}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>  
                                        <Col md={1} className="mb-3">คน</Col>       
                                    </Row>     
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel('', Inputs.trainee)}</Col> 
                                        <Col md={9} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.trainee}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            /> 
                                        </Col>        
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('1.6 ', Inputs.lecturer_amount)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.lecturer_amount}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col> 
                                        <Col md={1} className="mb-3">คน</Col>       
                                    </Row>     
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel('', Inputs.lecturer)}</Col> 
                                        <Col md={9} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.lecturer}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            /> 
                                        </Col>        
                                    </Row>     


                                    <Row className="mt-3">
                                        <Col md={12} className="mb-3">
                                            <label className="form-label"><b>2. หมวดค่าใช้จ่าย</b></label>
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('2.1 ', Inputs.actual_expenses_total, 'รวม')}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.actual_expenses_total}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col> 
                                        <Col md={2} className="mb-3">
                                            <div className="d-flex justify-content-between">
                                                <span>บาท</span>
                                                <span>คิดเป็นร้อยละ</span>
                                            </div>
                                        </Col>   
                                        <Col md={2} className="mb-3">100</Col>         
                                    </Row> 
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('2.2 ', Inputs.registration_fee_employer_expenses)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.registration_fee_employer_expenses}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col> 
                                        <Col md={2} className="mb-3">
                                            <div className="d-flex justify-content-between">
                                                <span>บาท</span>
                                                <span>คิดเป็นร้อยละ</span>
                                            </div>
                                        </Col> 
                                        <Col md={1} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.registration_fee_employer_expenses_percent.id}
                                                name={ReadOnlys.registration_fee_employer_expenses_percent.id}
                                                value={
                                                    util.formatNumber(
                                                    (Number(Inputs.registration_fee_employer_expenses.value) * 100) /
                                                    Number(Inputs.actual_expenses_total.value)
                                                )}
                                                placeholder={ReadOnlys.registration_fee_employer_expenses_percent.label}
                                                disabled={true}
                                            />   
                                        </Col>
                                    </Row> 
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('2.3 ', Inputs.eec_request_support_budget, ' (ไม่เกินร้อยละ 50)')}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.eec_request_support_budget}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)} 
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col> 
                                        <Col md={2} className="mb-3">
                                            <div className="d-flex justify-content-between">
                                                <span>บาท</span>
                                                <span>คิดเป็นร้อยละ</span>
                                            </div>
                                        </Col>
                                        <Col md={1} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.eec_request_support_budget_percent.id}
                                                name={ReadOnlys.eec_request_support_budget_percent.id}
                                                value={util.formatNumber(
                                                    (Number(Inputs.eec_request_support_budget.value) * 100) /
                                                    Number(Inputs.actual_expenses_total.value)
                                                )}
                                                placeholder={ReadOnlys.eec_request_support_budget_percent.label}
                                                disabled={true}
                                            />   
                                        </Col>
                                    </Row>         

                                    <Row className="mt-3">
                                        <Col md={12} className="mb-3"> 
                                            <label className="form-label"><b>3. การเบิกจ่ายเงินสนับสนุน</b></label>
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('3.1 ', Inputs.eec_pay_support_budget, ' จำนวน')}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.eec_pay_support_budget}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>
                                        <Col md={1} className="mb-3">บาท</Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3"></Col> 
                                        <Col md={5} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.eec_pay_support_budget_text.id}
                                                name={ReadOnlys.eec_pay_support_budget_text.id}
                                                value={util.numberToThaiText(Inputs.eec_pay_support_budget.value)}
                                                placeholder={ReadOnlys.eec_pay_support_budget_text.label}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('3.2 ', Inputs.receiver)}</Col> 
                                        <Col md={5} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.receiver}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel('', Inputs.address)}</Col> 
                                        <Col md={5} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.address}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel('', Inputs.tax_id)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.tax_id}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>
                                    </Row>   
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('3.3 ', Inputs.account_name)}</Col> 
                                        <Col md={3} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.account_name}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col> 
                                    </Row>    
                                    <Row>
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel('', Inputs.account_number)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.account_number}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>   
                                        <Col md={1} className="mb-3 text-end">{util.formatLabel('', Inputs.bank)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.bank}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>
                                        <Col md={1} className="mb-3 text-end">{util.formatLabel('', Inputs.branch)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.branch}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => await onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />    
                                        </Col>  
                                    </Row>       

                                    <Row className="mt-3">
                                        <Col md={12} className="mb-3">
                                            <label className="form-label"><b>4. เอกสารแนบ (กรุณาแนบตามลำดับเอกสาร)</b></label>
                                        </Col>
                                    </Row>  
                                    <Row> 
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.report_eec_hdc_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row> 
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.eb_02_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>   
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.training_result_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>   
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.income_expense_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                            <label className="title-xs text-muted mt-2">(สามารถใช้แบบฟอร์มของหน่วยงานจัดอบรมได้)</label>
                                        </Col>
                                    </Row>  
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.payslip_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>      
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.eb_04_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>   
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.photo_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>      
                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.lecturer_profile_doc}
                                                hr={true}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>      

                                    <Row className="mt-3">
                                        <Col md={6} className="mb-3">
                                            <label className="form-label">ข้าพเจ้าฯ ขอรับรองว่าข้อความและเอกสารข้างต้นเป็นความจริงทุกประการ</label>   
                                        </Col>  
                                    </Row>   
                                    <Row className="mt-3">
                                        <Col md={3} className="mb-3 text-end">{util.formatLabel(null, Inputs.fullname)}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.fullname}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />  
                                        </Col> 
                                        <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.position)}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.position}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />  
                                        </Col> 
                                        <Col md={1} className="mb-3">{util.formatLabel(null, Inputs.form_date)}</Col>
                                        <Col md={2} className="mb-3">
                                            <CustomDatePicker
                                                element="Inputs"
                                                input={Inputs.form_date}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                                disabled={!AllowUsersTypes.includes(UserCookie?.types)}
                                            />
                                        </Col>     
                                    </Row>                  

                                </Col>
                            </Row>          
                            
                        </Container>  
                    </SimpleBar>

                </Offcanvas.Body>

                <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                    
                    <CommonLoadingBar isLoading={isLoading} />

                    <div className="d-flex justify-content-end mt-2">
                        <CommonButton 
                            task={mode} 
                            disabled={isLoading ? true : Submit ? false : true}
                            callback={async (e) => { 
                                await onSubmit(e);
                            }} 
                        />

                        {Action.Mode === 'new' && (
                            <CommonButton 
                                task="discard" 
                                inlineClass="ms-1" 
                                disabled={isLoading} 
                                callback={(e) => onDiscardSubmit(false)} 
                            />
                        )}
                    </div>
                </div>
            </Offcanvas>
            </>
        );
    }
    
}

export default InputEB03DataCourse;         